import { AfterContentInit, AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router'
import { ColorProductoDTO } from 'src/app/model/colorProductoDTO';
import { PedidoTemp } from 'src/app/model/pedidoTemp';
import { ProductoRelacionadoDTO } from 'src/app/model/productoRelacionadoDTO';
import { ProductosDTO } from 'src/app/model/productosDTO';
import { stockDTO } from 'src/app/model/stockDTO';
import { TokenStorageService } from 'src/app/services/api/TokenStorageService';
import { ColorService } from 'src/app/services/api/color.service';
import { ProductoDTOService } from 'src/app/services/api/productoDTO.service';
import { db } from 'src/app/services/bd/bd';
import { environment } from 'src/environments/environment';
import { Location, ViewportScroller } from '@angular/common';
import { ColorERP } from 'src/app/model/ColorERP';
import { ColorERPService } from 'src/app/services/api/colorERP.service';
import { StockERPService } from 'src/app/services/api/stockERP.service';
import { StockERPDTO } from 'src/app/model/stockERPDTO';
import { PrecioERPService } from 'src/app/services/api/precioERP.service';
import { PreciosERP } from 'src/app/model/preciosERP';
import { PedidoDTOService } from 'src/app/services/api/pedidoDTO.service';
import { TokenStorageServiceCliente } from 'src/app/services/api/TokenStorageServiceCliente';
import { HostListener } from '@angular/core';
declare let $: any;
@Component({
  selector: 'app-pedido',
  templateUrl: './pedido.component.html',
  styleUrls: ['./pedido.component.css']
})
export class PedidoComponent implements OnInit,AfterViewInit {
  @HostListener('window:scroll', [])
  onWindowScroll() {
   if (
     document.body.scrollTop > 100 ||
     document.documentElement.scrollTop > 100
   ) {
     document.getElementById('appear')?.classList.add('active')
   }
   else(
     document.getElementById('appear')?.classList.remove('active')
   )
 }
 title = 'WhatsApp';

  @ViewChild('myModal')myModal!: ElementRef;
  @ViewChild('myModalError')myModalError!: ElementRef;
  CantidadItem:string="0";
  formPedido!: FormGroup;
  stock:stockDTO[]=[];
  stockERPDTO:StockERPDTO[]=[];
  colores:ColorProductoDTO[]=[];
  idproductoDTO:number=0;
  firstIdTalla:number=0;
  modeloDTO:String="";
  detallesDTO:String="";
  marcaDTO:String="";
  precioDTO:number=0;
  precioFinalDTO:number=0;
  codigoDTO:String="";
  idCategoriaDTO:number=0;
  imagenDTO:String="";
  imagenDTO2:String="";
  imagenDTO3:String="";
  alturaDTO:String="";
  colorDTO:String="";
  valorcolorDTO:String="";
  tallaDTO:String="";
  tallaERPDTO:String="";
  descripcionDTO:String="";
  urlServerUpload$ : string = `${environment.HOST}/api/media/`;
  pedidoTemp:PedidoTemp[]=[];
  tipoMedia$ : String = "/0";
  idColorDTO:number=0;
  colorIdDTO:number=0;
  idTallaDTO:number=0;
  errorForm:String[]=["0","0","0"];
  modoPedido:number=0;
  precioAnterior:number=0;
  valorDescuento:number=0;
  productosRel:ProductoRelacionadoDTO[]=[];
   productosdto:ProductosDTO[]=[];
   colorERP:ColorERP[]=[];
   preciosErp:PreciosERP[]=[];
  activaPago:number=0;
  valorPagoDiferencia:number=0;
  idPedidoDTO:number=0;
  idProductoAnterior:number=0;
  indiceDetallePedidoDTO:number=0;
  colorErpDTO:String="";
  msjTiempoEtrega:String="";
  TotalExistenciaERP:number=0;
  codigoErpDTO:number=0;
  codigoErpMarcaDTO:String="";
  descuentoDTO:number=0;
  limitarExistenciaDTO:String="NO";
  mensajeForm:String="";
  formBuscar!: FormGroup;
  modoBusqueda:boolean=false;
  countpedido:string="0";
  nombreCuenta:String="Mi cuenta";
  tieneSession:boolean=false ;
  tipoMedia2$ : String = "/0";
  idUsrDTO:number=0;
ocultar:boolean=false;
  content:any = [];
  currentPage:number=0;
  totalPages:number=0;
  ocultarCarrito:boolean=false;
  page = 0;
  size = 6;
  order = 'descripcion';
  asc = true;




  urlServerUploadArticulos$ : string = `${environment.HOST}/api/media/`;
  mostrarRelacionados:boolean=false;
  constructor(
    private scroller: ViewportScroller,
     private activatedRoute : ActivatedRoute,
     private productoDTOService : ProductoDTOService,
     private stockERPService:StockERPService,
     private router:Router,
     private colorService : ColorService,
     private tokenStorage: TokenStorageServiceCliente,


    private precioErpService:PrecioERPService,
     private colorERPService:ColorERPService,
    
   

     ){
    activatedRoute.params.subscribe( prm => {
        console.log(`El id es: ${prm['idProducto']}`);
        this.idproductoDTO=prm['idProducto'];
       this.modoPedido=prm['modoPedido'];
       this.idPedidoDTO=prm['idPedido'];
       this.idProductoAnterior=prm['idProductoAnterior'];
       this.precioAnterior=prm['precioAnterior'];
       this.indiceDetallePedidoDTO=prm['indiceDetallePedido'];
      

    })
}
ngAfterViewInit (): void {
  }




ngOnInit() {
 
  this.formBuscar = new FormGroup({
    'txtBuscar' : new FormControl('', Validators.required),
  });
 

  this.OnContarPedido();




  if (this.tokenStorage.getToken()!==null) {
    let json = JSON.stringify(this.tokenStorage.getUser());
    let data=JSON.parse(json.toString());
    this.idUsrDTO=data.idUsuario;
    this.nombreCuenta=data.nombre;
    this.tieneSession=true ;
      }


  this.CantidadItem=localStorage.getItem('countPedido')+"";
  this.formPedido = new FormGroup({
    'cmbCantidad' : new FormControl('', Validators.required),
    'cmbTalla' : new FormControl('', Validators.required),
    'cmbColor' : new FormControl('', Validators.required),
  });



  this.getProductosDTOById(this.idproductoDTO);


this.OnStockProducto(this.idproductoDTO);



 
this.formPedido.controls['cmbCantidad'].setValue(1);


//window.scroll({ top: 0, left: 0, behavior: 'smooth' });


this.OnProductosRelacionadosByIdProducto(this.idproductoDTO);


this.scroller.scrollToAnchor("targetInicio");


}


logout(){
  localStorage.removeItem('shopping');
  this.tokenStorage.signOut();
  
  this.router.navigateByUrl('/inicio');
}



OnRegresarInicio(){

 if (this.modoPedido==0){  this.router.navigate(['/inicio',])}

 if (this.modoPedido==1){  window.history.back();}


}

OnVerificarSesion(){
  if (this.tokenStorage.getToken()==null) {
    
    // this.roles = this.tokenStorage.getUser();
     this.router.navigateByUrl('/registro-cliente');
   }
 
}



OnAbrirDialogo(){

  if (this.ValidarNuevoRegistro()==0){

// verificar existencia del ERP

if (this.precioDTO>0){
 
  this.scroller.scrollToAnchor("targetInicio");


 // this.OnGetStockERP(this.modeloDTO,this.tallaERPDTO);
this.OnGuardarPedido();




}else {
  this.mensajeForm="Precio NO DISPONIBLE";
  
    $(this.myModalError.nativeElement).modal('show'); 

}





  }else{
    this.mensajeForm="Seleccione Talla y Color";
    this.ocultar=true;
    $(this.myModalError.nativeElement).modal('show'); 
  }




 

}

Mostrar1(){
  this.ocultar=false;
}
  ValidarNuevoRegistro(){
  let rs:number=0;
  let rs1:number=0;
  let rs2:number=0;
  let rs3:number=0;
 
  
    if (this.colorIdDTO > 0 ){
     
      rs1= 0;
      
    }else {
      
      rs1= 1;

    }

    

       if (this.idTallaDTO > 0 ){
     
      rs2= 0;

       }else {
       
        rs2= 1;

       }

       if (this.formPedido.value['cmbCantidad']>0){
       
        rs3= 0;
       }else {
        
        rs3= 0;

       }



rs=rs1+rs2+rs3;
  
  
  
return rs;
  }





  OnSelectProducto(idproducto:any){
    this.router.navigate(['/pedido', idproducto,0,0,0,0,0])
    .then(() => {
      window.location.reload();

    });


  }

  OnSelectProducto02(_idproducto:any){

    this.router.navigate(['/pedido', _idproducto,0,0,0,0,0])

    .then(() => {
      window.location.reload();
    });
  

  }
  
 
OnGuardarPedido(){


  this.modoPedido = Number(localStorage.getItem('modo_pedido_ls'));



  for (let n = 1; n <= this.formPedido.value['cmbCantidad']; ++n) {



    if (this.modoPedido==1){
      this.precioFinalDTO=this.precioDTO-this.precioAnterior;
      this.precioDTO=this.precioDTO-this.precioAnterior;
    }
  
    const lista: PedidoTemp= {
      indiceDetallePedido:this.indiceDetallePedidoDTO,
      idPedido:this.idPedidoDTO,
      idProducto:this.idproductoDTO,
      modelo:this.modeloDTO+"",
      descripcion:this.descripcionDTO+"",
      color:this.valorcolorDTO+"",
      talla:this.tallaDTO+"",
      cantidad:1,
      precio:this.precioDTO,
      descuento:this.descuentoDTO,
      precioFinal:this.precioFinalDTO,
      importe:1 * ( Number(this.precioFinalDTO)),
      imagen:this.imagenDTO+"",
      idColor:0,
      idTalla:this.idTallaDTO,
      idProductoAnterior: this.idProductoAnterior,
      colorErp:this.colorErpDTO,
      colorIdErp:this.colorIdDTO,
      tallaErp:this.tallaERPDTO,
      codigoErp:this.codigoErpDTO,
      limitarExistencia:this.limitarExistenciaDTO,
      msgDisponibilidad:""
      
    }
  
  
    this.pedidoTemp.push(lista);
    let json = JSON.stringify(lista);
    
   let data=JSON.parse(json.toString());
    this.AgregarACarrito(data);

   

  }



  
    if (this.modoPedido==0){
 


       

    this.router.navigate(['/articulos', this.idCategoriaDTO])

    .then(() => {
      window.location.reload();
      
      
    });
 

    
  }
  
   
    if (this.modoPedido==1){





   
        this.router.navigate(['/carrito'])
  
      

    

 

    }
  

 

 


}


OnContarPedido(){
 
  this.ContarRegistros().then(data => {
    this.CantidadItem=data+"";
  

  });
 
}


async AgregarACarrito(datos:any) {




  await db.detallePedidoBD.add(datos);

 
 

 
}


async ContarRegistros() {
  return await db.detallePedidoBD.count();
  }


async ModificarDeCarrito(datos:any) {
  await db.detallePedidoBD.put(datos);
}



getProductosDTOById(id:number){
  this.productoDTOService.getProductosDTOById(id).subscribe(response =>{
    for(let dato of response) {
  this.idproductoDTO=parseInt(dato.idProducto+"");
  this.modeloDTO=dato.modelo+"";
  this.marcaDTO=dato.marca+"";
  this.codigoDTO=dato.descripcion+"";
  this.imagenDTO=dato.imagen+""; 
  this.descripcionDTO=dato.descripcion+"";
  this.detallesDTO=dato.detalles+"";
  this.imagenDTO2=dato.imagen2+"";
  this.imagenDTO3=dato.imagen3+"";
  this.alturaDTO=dato.altura+"";
  this.codigoErpMarcaDTO=dato.codigoErpMarca+"";
  this.descuentoDTO=Number(dato.precio2)/100;
  this.limitarExistenciaDTO=dato.limitarExistencia+"";
  this.idCategoriaDTO=parseInt(dato.idCategoria+"");

 
    }








    this.OnGetColoresERP(this.modeloDTO, this.codigoErpMarcaDTO);

  });

 

}



OnSelectColorERP(_colorId:any,_color:any){


  //let cadena = this.formPedido.value['cmbColor'];
  //let subs = cadena.split(',');

//this.colorIdDTO=subs[0];
//this.colorErpDTO=subs[1];


this.colorIdDTO=_colorId;
this.colorErpDTO=_color;
this.OnGetPrecioERP();
}




// OnGetColores(){
//   this.colorERPService.getColores().subscribe(response =>{
//     console.log(response)
//    // return this.colorERP=response
//   });
// }

//         referrer: 'http://localhost:4200',
//         referrerPolicy: 'origin',
//        mode: 'no-cors',
//         method: 'GET',


//   OnGetColores(){



//  let bodys=JSON.stringify({
//       "MessageTypeId": "0200",
//       "ProcessingCode": "020000",
//       "SystemsTraceNo": "100052",
//       "TimeLocalTrans": "",
//       "DateLocalTrans": "",
//       "PosEntryMode": "012",
//       "Nii": "003",
//       "PosConditionCode": "00",
//       "AdditionalData": "",
//       "OrderInformation": "",
//       "FormatId": "1",
//       "Merchant": {
//         "TerminalId": "20240602",
//         "CardAcqId": "20240006"
//       },
//       "Card": {
//         "Type": "",
//         "PrimaryAcctNum": "",
//         "DateExpiration": "",
//         "Cvv2": "",
//         "Track2Data": "",
//         "CardTokenId": "",
//         "UniqueCodeofBeneciary": ""
//       },
//       "Amount": {
//         "AmountTrans": "",
//         "AmountDiscount": "",
//         "RateDiscount": "",
//         "AdditionalAmounts": "",
//         "TaxDetail": [
//         ]
//       },
//       "PrivateUse60": {
//         "BatchNumber": ""
//       },
//       "PrivateUse63": {
//         "LodgingFolioNumber14": "",
//         "NationalCard25": "",
//         "HostReferenceData31": "",
//         "TaxAmount1": ""
//       },
//       "TokenManagement": {
//         "Type": "",
//         "ActionMethod": ""
//       },
//       "Customer": {
//         "CustomerTokenId": "",
//         "FirstName": "",
//         "LastName": "",
//         "TaxId": "",
//         "IdentificationType": "",
//         "PersonalId": "",
//         "Email": "",
//         "PhoneNumber": ""
//       },
//       "BillTo": {
//         "FirstName": "",
//         "LastName": "",
//         "Company": "",
//         "AddressOne": "",
//         "AddressTwo": "",
//         "Locality": "",
//         "AdministrativeArea": "",
//         "PostalCode": "",
//         "Country": "",
//         "Email": "",
//         "PhoneNumber": ""
//       },
//       "ShipTo": {
//         "DefaultSt": "",
//         "FirstName": "",
//         "LastName": "",
//         "Company": "",
//         "AddressOne": "",
//         "AddressTwo": "",
//         "Locality": "",
//         "AdministrativeArea": "",
//         "PostalCode": "",
//         "Country": "",
//         "Email": "",
//         "PhoneNumber": "",
//         "ShippingAddressTokenId": ""
//       },
//       "PaymentInstrument": {
//         "PaymentInstrumentTokenId": ""
//       },
//       "CustomerPaymentInstrument": {
//         "CustomerPaymentInstrumentTokenId": "",
//         "DefaultCpi": ""
//       },
//       "PayerAuthentication": {
//         "Step": "",
//         "UrlCommerce": "",
//         "ReferenceId": ""
//       }
//     });







// fetch("https://epaytestvisanet.com.gt:4433/V3/api/AuthorizationPaymentCommerce?MerchantUser",{
//   method:'POST',
//     headers:{
//       'Content-Type':'application/json',
//       'MerchantUser': 'C59791C8C516C45AD5626A147C3AC4CB2AB49EAC11A543DF4EFD6350FAFD9E1D',
//       'ShopperIP': '1.1.1.1',
//     'MerchantPasswd': '19EAD7684EAC623E1A2B7EF785058CFD8441DC1FFD63145D23BDBF9829E3EA91',
//     'PaymentgwIP': '1.1.1.1',
//     'MerchantServerIP': '1.1.1.1'
//   },
//   body:bodys



// }) .then((response) => response.json())
// .then(console.log);;









//     // try {
//     //   // Await the fetch response from the API endpoint
//     //   const response = await fetch('https://jsonplaceholder.typicode.com/posts');
      
//     //   // Check if the response is ok (status in the range 200-299)
//     //   if (!response.ok) {
//     //     throw new Error('Network response was not ok');
//     //   }
      
//     //   // Await the JSON data from the response
//     //   const data = await response.json();
      
//     //   // Log the data to the console
//     //   console.log(data);
//     // } catch (error) {
//     //   // Handle any errors that occurred during the fetch
//     //   console.error('Fetch error:', error);
//     // }



//     // try {
//     // //   let headers = new Headers();
//     // //   headers.append('ShopperIP', '1.1.1.1');
//     // //  headers.append('MerchantPasswd', '19EAD7684EAC623E1A2B7EF785058CFD8441DC1FFD63145D23BDBF9829E3EA91');
//     // //  headers.append('PaymentgwIP', '1.1.1.1');
//     // //  headers.append('MerchantServerIP', '1.1.1.1');
   
    
      

//     //   // Await the fetch response from the API endpoint
//     //   const response = await fetch('https://epaytestvisanet.com.gt:4433/V3/api/AuthorizationPaymentCommerce?MerchantUser',{
      
//     //  mode:'no-cors',
//     //   referrerPolicy: 'origin',
//     //   method:'POST',
//     //   headers:{
//     //     'Content-Type':'application/json',
//     //     'MerchantUser': 'C59791C8C516C45AD5626A147C3AC4CB2AB49EAC11A543DF4EFD6350FAFD9E1D',
//     //     'ShopperIP': '1.1.1.1',
//     //   'MerchantPasswd': '19EAD7684EAC623E1A2B7EF785058CFD8441DC1FFD63145D23BDBF9829E3EA91',
//     //   'PaymentgwIP': '1.1.1.1',
//     //   'MerchantServerIP': '1.1.1.1'
//     // },
//     //   body:bodys
//     //   });
      
//     //   // Check if the response is ok (status in the range 200-299)
//     //   if (!response.ok) {
//     //     throw new Error('Network response was not ok');
//     //   }
      
//     //   // Await the JSON data from the response
//     //   const data = await response.json();
      
//     //   // Log the data to the console
//     //   console.log(data);
//     // } catch (error) {
//     //   // Handle any errors that occurred during the fetch
//     //   console.error('Fetch error:', error);
//     // }


//     // const xhr = new XMLHttpRequest();
//     // xhr.open('GET', 'https://storenew-001-site3.atempurl.com/api/producto?modelo=3356500&ClaveMarca=A');
//     // xhr.onload = function() {
//     //   if (xhr.status >= 200 && xhr.status < 300) {
//     //     console.log(JSON.parse(xhr.responseText));
//     //   } else {
//     //     console.error('XMLHttpRequest error:', xhr.statusText);
//     //   }
//     // };
//     // xhr.onerror = function() {
//     //   console.error('XMLHttpRequest error:', xhr.statusText);
//     // };
//     // xhr.send();




    


// }

OnGetColoresERP(_modelo:String,_claveMarca:String){



  this.colorERPService.getColorERP(_modelo,_claveMarca).subscribe(response =>{
    console.log(response)
    return this.colorERP=response
  })
}

OnGetStockERP(_modelo:String,_tallaerp:any){


  this.TotalExistenciaERP=0;
this.stockERPService.getStockERP(this.codigoErpDTO).subscribe(response =>{
   // console.log(response)
   
   
   for(let datos of response) {
this.TotalExistenciaERP=Number(this.TotalExistenciaERP)+Number(datos.existencia);
this.codigoErpDTO=Number(datos.codigoErp);
   }
   
   
if (this.TotalExistenciaERP>0){

this.msjTiempoEtrega="Tiempo de entrega:  2-3 días";

}else {


  //this.msjTiempoEtrega="Tiempo de entrega:  5-6 días";

  let fechaActual = new Date();
  const fechaComoCadena = fechaActual.getFullYear()+"-"+fechaActual.getMonth()+"-"+fechaActual.getDate()+ " 23:59:00"; // día lunes

  const dias = [
    'domingo',
    'lunes',
    'martes',
    'miércoles',
    'jueves',
    'viernes',
    'sábado'
  ];
  const numeroDia = new Date(fechaComoCadena).getDay();
  const nombreDia = dias[numeroDia];
 // console.log("Nombre de día de la semana: ", fechaActual.getDate());

if (nombreDia=='domingo'){
  this.msjTiempoEtrega="Tiempo de entrega: 11 días aprox.";
}

if (nombreDia=='lunes'){
  this.msjTiempoEtrega="Tiempo de entrega: 10 días aprox.";
}

if (nombreDia=='martes'){
  this.msjTiempoEtrega="Tiempo de entrega: 9 días aprox.";
}

if (nombreDia=='miércoles'){
  this.msjTiempoEtrega="Tiempo de entrega: 8 días aprox.";
}

if (nombreDia=='jueves'){
  this.msjTiempoEtrega="Tiempo de entrega: 7 días aprox.";
}

if (nombreDia=='viernes'){
  this.msjTiempoEtrega="Tiempo de entrega: 13 días aprox.";
}

if (nombreDia=='sábado'){
  this.msjTiempoEtrega="Tiempo de entrega: 12 días aprox.";
}



}
$(this.myModal.nativeElement).modal('show'); 

  })
}



OnGuardarStockTemporal(codigoErp:number,stock:number){
  this.productoDTOService.guardaStockTemporal(codigoErp,stock).subscribe(response =>{
    console.log(response)
  
  })
}



OnStockProducto(id:number){
  this.productoDTOService.getStockByProducto(id).subscribe(response =>{
    console.log(response)
    return this.stock=response
  })
}

OnProductosRelacionadosByIdProducto(id:number){
  this.productoDTOService.getProductoRelacionadoByIdProducto(id).subscribe(response =>{
    console.log(response)
    this.mostrarRelacionados=true ;
    return this.productosRel=response
  })
}
OnFindFirstItemTalla(id:number){

  let xxx:Number=0;
  this.productoDTOService.getStockByProducto(id).subscribe(response =>{
    for(let datos of response) {
     // this.OnSelectFirstTalla(datos.idTalla);
break;
        }
  })

 

}


OnSelectFirstTalla(id:any){

//  this.formPedido.controls['cmbTalla'].setValue(id);
//this.OnSelectTalla();
}


OnColoresStockProducto(id:number){
  this.productoDTOService.getColorStockByProductos(id).subscribe(response =>{
    console.log(response)
    return this.colores=response
  })
}


OnHabilitarBusqueda(){
  this.ocultarCarrito=true;
}

OnCerrarBusqueda(){
  this.ocultarCarrito=false;
}

OnCerrarDialogo(){
  this.ocultar =false;
}



OnSelectTalla(idTalla:any,nMx:any,talla:any){

  let cadena = this.formPedido.value['cmbTalla'];
  let subs = cadena.split(',');

  //idTalla:any,nMx:any,talla:any
  //this.idTallaDTO=parseInt(this.formPedido.value['cmbTalla']);


  //this.idTallaDTO=subs[0];
  //this.tallaERPDTO=subs[1];
 // this.tallaDTO=subs[2];

 this.idTallaDTO=idTalla;
  this.tallaERPDTO=nMx;
  this.tallaDTO=talla;


this.OnGetPrecioERP();




}

OnGetPrecioERP(){

  this.precioErpService.getPrecioERP(this.modeloDTO,this.codigoErpMarcaDTO,this.colorIdDTO,this.tallaERPDTO).subscribe(response =>{
  //  console.log(response)

  let jsonn = JSON.stringify(response);
 
  let data=JSON.parse(jsonn);



let keys = Object.keys(data); 
let key = keys[0];
this.codigoErpDTO=Number(data[key]);
let key2 = keys[1];
this.precioDTO=Number(data[key2]);
this.precioFinalDTO=Number(data[key2]);


if (this.descuentoDTO>0){
 
  this.valorDescuento= Number(this.precioDTO)*Number(this.descuentoDTO);
  this.precioFinalDTO=  Math.round( this.precioDTO- Number(  this.valorDescuento));

}else {
  this.precioFinalDTO=this.precioDTO;
}



  })

}

OnSelectColor(id:any){
 this.idColorDTO=parseInt(id);

  for (let lista of this.stock){
    if (lista.idColor== this.idColorDTO){
      this.valorcolorDTO=lista.valorColor+"";
      
      break;
    }

}



  
  }


  OnBuscarAll(){

    this.modoBusqueda=true;
    this.currentPage=0;
    this.content=[];

this.CargarPorDescripcionPg();

    }


  

    CargarPorDescripcionPg(){
        

      this.productoDTOService.getProductosDTOByDescripcionPg(this.currentPage, this.size, this.order, this.asc,0,this.formBuscar.value['txtBuscar']).subscribe(
        data => {
          this.content.push(...data.content);
         // this.isFirst = data.first;
         // this.isLast = data.last;
        //  this.totalPages = new Array(data['totalPages']);
        this.totalPages=data.totalPages;
          console.log(data);
        },
        err => {
          console.log(err.error);
        }
      );

    }


    onScroll(){
      if(this.modoBusqueda==false){
        //this.currentPage++;
       // this.cargarProductoPg();
      }else{
        this.currentPage++;
        this.CargarPorDescripcionPg();
      }

     
    }


}


function getWeekDay(date: Date): any {
  throw new Error('Function not implemented.');
}

